import ContactForm from '../components/contact';
import Seo from '../components/Seo';

function ContactPage() {
    return (
      <div className="block contact-page">
        <Seo path='/contact' titleKey='seo.contact.title' descriptionKey='seo.contact.description' />
        <ContactForm />
      </div>
    );
  }
  
  export default ContactPage;